import React from "react";
import { useAuth } from "./auth/AuthContext";
import { useRouter } from "./router";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Empresa } from "./pages/Empresa";
import { Usuarios } from "./pages/Usuarios";
import { Roles } from "./pages/Roles";
import { Parametros } from "./pages/Parametros";
import { Catalogos } from "./pages/Catalogos";
import { Productos } from "./pages/Productos";
import { Auditoria } from "./pages/Auditoria";
import { Compras } from "./pages/Compras";
import { Produccion } from "./pages/Produccion";
import { Costeo } from "./pages/Costeo";
import { Inventarios } from "./pages/Inventarios";
import { Comercial } from "./pages/Comercial";
import { Gerencial } from "./pages/Gerencial";
import { Contabilidad } from "./pages/Contabilidad";
import { Nomina } from "./pages/Nomina";
import { Cumplimiento } from "./pages/Cumplimiento";
import { Pos } from "./pages/Pos";
import { PosMostrador } from "./pages/PosMostrador";
import { Notas } from "./pages/Notas";
import { Tesoreria } from "./pages/Tesoreria";
import { Activos } from "./pages/Activos";
import { Informes } from "./pages/Informes";
import { Reportes } from "./pages/Reportes";
import { Restaurante } from "./pages/Restaurante";
import { Dian } from "./pages/Dian";
import { SigeproEP } from "./pages/SigeproEP";
import { SuperadminApp } from "./pages/Superadmin";
import { Shell } from "./components/Shell";

const RUTAS: Record<string, React.ComponentType> = {
  "/": Dashboard,
  "/empresa": Empresa,
  "/usuarios": Usuarios,
  "/roles": Roles,
  "/parametros": Parametros,
  "/catalogos": Catalogos,
  "/productos": Productos,
  "/auditoria": Auditoria,
  "/compras": Compras,
  "/produccion": Produccion,
  "/costeo": Costeo,
  "/inventarios-op": Inventarios,
  "/comercial": Comercial,
  "/gerencial": Gerencial,
  "/contabilidad": Contabilidad,
  "/nomina": Nomina,
  "/cumplimiento": Cumplimiento,
  "/pos": Pos,
  "/pos/mostrador": PosMostrador,
  "/notas": Notas,
  "/tesoreria": Tesoreria,
  "/activos": Activos,
  "/informes": Informes,
  "/reportes": Reportes,
  "/restaurante": Restaurante,
  "/dian": Dian,
  "/sigepro-ep": SigeproEP,
};

function NoEncontrado() {
  return (
    <Shell titulo="Página no encontrada" breadcrumb="Core">
      <div className="card p-6 text-sm text-textmuted">
        La sección solicitada no existe o pertenece a una fase aún no implementada del plan SIG-ARQ-001.
      </div>
    </Shell>
  );
}

function ModuloNoDisponible() {
  return (
    <Shell titulo="Módulo no disponible" breadcrumb="Licenciamiento">
      <div className="card p-6 text-sm text-textmuted max-w-lg">
        Su empresa no tiene contratado este módulo, o su licencia venció. Contacte al administrador de SIGEPRO
        para activarlo.
      </div>
    </Shell>
  );
}

export function App() {
  const { cargando, sesion, moduloDisponibleParaRuta } = useAuth();
  const { path } = useRouter();

  // El panel de superadministrador (licenciamiento de módulos por cliente)
  // es una aplicación completamente aparte: su propia sesión, su propio
  // login (ver pages/Superadmin.tsx y superadminApi.ts) — se resuelve ANTES
  // de mirar la sesión de cliente (`sesion`, de AuthContext) para que
  // ninguna de las dos interfiera con la otra en el mismo navegador.
  if (path.split("?")[0].startsWith("/superadmin")) {
    return <SuperadminApp />;
  }

  if (cargando) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-navy to-navy-light text-white text-sm gap-3">
        <span className="h-4 w-4 rounded-full border-2 border-white/30 border-t-white animate-spin" />
        Cargando SIGEPRO ERP...
      </div>
    );
  }

  if (!sesion) {
    return <Login />;
  }

  const [pathname] = path.split("?");
  if (RUTAS[pathname] && !moduloDisponibleParaRuta(pathname)) {
    return <ModuloNoDisponible />;
  }
  const Pagina = RUTAS[pathname] || NoEncontrado;
  return <Pagina />;
}
